import { render } from "./QrCodeView.vue?vue&type=template&id=47b9193b&scoped=true"
import script from "./QrCodeView.vue?vue&type=script&lang=js"
export * from "./QrCodeView.vue?vue&type=script&lang=js"

import "./QrCodeView.vue?vue&type=style&index=0&id=47b9193b&scoped=true&lang=css"

import exportComponent from "/home/christian/Trabalho/fish_coletor/Coletor-APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b9193b"]])

export default __exports__